import React, { PropsWithChildren } from 'react';

import { BaseProps, RefOrUndefined } from './Types';

function constructMenu(
  { className, ...props }: PropsWithChildren<BaseProps>,
  ref: RefOrUndefined
) {
  return <div {...props} ref={ref} className={className} />;
}

export const Menu = React.forwardRef(constructMenu);
